// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import TableOutlined from '/codebuild/output/src521722968/src/akiya_management/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import ProfileOutlined from '/codebuild/output/src521722968/src/akiya_management/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ProfileOutlined';
import FormOutlined from '/codebuild/output/src521722968/src/akiya_management/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FormOutlined';
export default { TableOutlined, ProfileOutlined, FormOutlined };
